import React from "react";
import {useTranslation} from "react-i18next";
import {TabView, TabPanel} from "primereact/tabview";
import AdminPageHeader from "../AdminPageHeader";
import EmailCampaignCompose from "./EmailCampaignCompose";
import EmailCampaignHistory from "./EmailCampaignHistory";
import EmailCampaignSuppression from "./EmailCampaignSuppression";

// Admin-only bulk email screen. Tabs: Compose (build + send a campaign),
// History (past campaigns with per-recipient status), and Suppression
// (manage the unsubscribe list). Admin-gated at the route level via
// AdminRequiredRoute.
export default function EmailCampaign() {
    const {t} = useTranslation();
    const [activeIndex, setActiveIndex] = React.useState(0);

    return (
        <React.Fragment>
            <AdminPageHeader title={t('email_campaign.title')}/>
            <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                <TabPanel header={t('email_campaign.tab_compose')}>
                    <EmailCampaignCompose/>
                </TabPanel>
                <TabPanel header={t('email_campaign.tab_history')}>
                    <EmailCampaignHistory active={activeIndex === 1}/>
                </TabPanel>
                <TabPanel header={t('email_campaign.tab_suppression')}>
                    <EmailCampaignSuppression active={activeIndex === 2}/>
                </TabPanel>
            </TabView>
        </React.Fragment>
    );
}
